import {Typography} from '@mui/material';
import React, {ReactNode} from 'react';

interface Props {
  children?: ReactNode;
  noBottomMargin?: boolean;
}

const PageTitle: React.FC<Props> = ({children, noBottomMargin}) => {
  return (
    <Typography
      sx={{
        mb: noBottomMargin ? 0 : 3,
        textTransform: 'uppercase',
      }}
      variant="h1">
      <em>{children}</em>
    </Typography>
  );
};

export default PageTitle;
